import { useMemo } from "react";
import { Link } from "react-router-dom";
import { WarningCircle } from "@phosphor-icons/react";
import { useFetch } from "@/lib/api";
import { buildLedger } from "@/lib/paychecks";
import { matchShortfalls } from "@/lib/ledgerExport";
import { usd } from "@/lib/format";

const YEAR = new Date().getFullYear();

export function MissedMatchAlert({ profile }) {
  const { data } = useFetch(`/paychecks?year=${YEAR}`);
  const misses = useMemo(() => (profile && data ? matchShortfalls(buildLedger(profile, YEAR, data.overrides)) : []), [profile, data]);
  if (!misses.length) return null;
  const total = misses.reduce((s, r) => s + (r.agency - r.actual_agency), 0);
  return (
    <div className="glass border-rose-300/80 dark:border-rose-500/40 p-5 mb-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4 fade-up" style={{ borderColor: undefined }} data-testid="missed-match-alert">
      <div className="flex gap-3">
        <WarningCircle size={22} weight="fill" className="text-rose-600 shrink-0 mt-0.5" />
        <div>
          <p className="font-medium text-slate-900 dark:text-white" data-testid="missed-match-summary">Agency match came in {usd(total, 2)} short on {misses.length} verified paycheck{misses.length > 1 ? "s" : ""}</p>
          <p className="text-sm text-muted-foreground mt-1" data-testid="missed-match-dates">
            {misses.slice(0, 4).map((r) => `${r.date} (${usd(r.actual_agency, 2)} vs ${usd(r.agency, 2)})`).join(" · ")}{misses.length > 4 ? ` · +${misses.length - 4} more` : ""}
          </p>
          <p className="text-xs text-muted-foreground mt-1">Check your LES and contact your agency payroll office if the shortfall is real.</p>
        </div>
      </div>
      <Link to="/paychecks" className="text-sm font-medium text-rose-700 dark:text-rose-400 underline shrink-0" data-testid="missed-match-review-link">Review ledger</Link>
    </div>
  );
}
